var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('monitoring-widget',{attrs:{"title":"Журнал обработки ТК","items":_vm.items,"isLoading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }